import React from "react";
import "./styles/Footer.css";

const Footer = () => {
  return (
    <>
      <footer className="c-footer">
        <div className="footer-info">
          Isaías Chávez / Sitio creado con: <p>React.js | HTML | JS | CSS |</p>{" "}
          Hosting: Netlify
        </div>
        <div className="social">
          <a href="https://www.facebook.com/profile.php?id=100002466696106">
            Facebook
          </a>
          
          <a href="https://www.instagram.com/soyisaiaschavez/?hl=es-la">
            Instagram
          </a>
           <a href="#!">Github</a>
          <a href="https://www.linkedin.com/in/isaiaschavez/">LinkedIn</a>
          
          <a href="wa.link/cvipv8">Whatsapp</a> |
        </div>
      </footer>
    </>
  );
};

export default Footer;
